export default [
   {
      path: '/agent',
      component: () => import ( '@/views/loud/agent/agent.vue')
   },
   {
      path: '/agent/Agentist',
      component: () => import ( '@/views/loud/agent/Agentist.vue')
   }
]    